import { reducers } from 'redux/core'


const { setPaymentData, resetPaymentData } = reducers.models.purchaseData

export default {
  setPaymentData,
  resetPaymentData,
}
